var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 96a48 48 0 1 0 0-96 48 48 0 0 0 0 96Zm8-79c-2 0-3 1-3 3v21c0 2 1 3 3 3h8c2 0 3-1 3-3V20c0-2-1-3-3-3h-8ZM9 53c4 20 20 35 39 35s35-15 39-35H9Zm21-36c-2 0-3 1-3 3v21c0 2 1 3 3 3h8c2 0 3-1 3-3V20c0-2-1-3-3-3h-8Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiIcon);
export default __webpack_public_path__ + "static/media/emoji_icon.ec8b6d0b6a525b9e9441f5d9d2914ef7.svg";
export { ForwardRef as ReactComponent };